<template>
  <b-form @submit.prevent="onSubmit()" class="filters-form">
    <b-form-row>
      <b-col md="12"><h5 class="search-title">Rezervari</h5></b-col>
      <b-col md="7">
        <b-form-row>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="Moneda"
              label-class="font-weight-bold"
              label-for="currency">
              <b-form-select
                id="currency"
                name="currency"
                size="sm"
                :options="currencyOptions"
                v-model="params.currency" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group class="my-0"
              label="Numar rezervare"
              label-class="font-weight-bold"
              label-for="booking-number"
              >
              <b-input
                type="text"
                name="rezervare"
                id="booking-number"
                v-model="params.bookingId"
                size="sm" />
              </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="Rezervare intre"
              label-for="bookingFrom"
              label-class="font-weight-bold">
                <DatePicker v-model="bookingFrom" key="bookingFrom" size="sm" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="si"
              label-for="bookingTo"
              label-class="font-weight-bold">
                <DatePicker v-model="bookingTo" key="bookingTo" size="sm" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="Plecare intre"
              label-for="travelFrom"
              label-class="font-weight-bold">
                <DatePicker v-model="travelFrom" key="travelFrom" size="sm" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="si"
              label-for="travelTo"
              label-class="font-weight-bold">
                <DatePicker v-model="travelTo" key="travelTo" size="sm" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="Cuvant cheie"
              label-class="font-weight-bold"
              label-for="key-word" d
              >
              <b-input
                type="text"
                name="keyWord"
                v-model="params.keyword"
                id="key-word"
                size="sm" />
              </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              class="my-0"
              label="Nume pasager"
              label-class="font-weight-bold"
              label-for="name"
              >
              <b-input
                type="text"
                name="pasager"
                v-model="params.name"
                id="name"
                size="sm" />
              </b-form-group>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col md="5" class="pt-4">
        <BookingSummary :results="results" :params="params"/>
      </b-col>
      <b-col md="12" sm="12" class="d-flex align-items-center justify-content-end">
        <b-button variant="outline-primary" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2">Cauta</span></b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>

import BookingSummary from './booking_summary'
import moment from 'moment'
import { currencies } from '@/shared/utils'
import DatePicker from 'b2b-common/components/datepicker'

export default {
  props: ['params', 'results'],
  components: { DatePicker, BookingSummary },
  computed: {
    bookingFrom: {
      get () {
        return this.params.bookingFrom ? moment(this.params.bookingFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    bookingTo: {
      get () {
        return this.params.bookingTo ? moment(this.params.bookingTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.bookingTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelFrom: {
      get () {
        return this.params.travelFrom ? moment(this.params.travelFrom, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelFrom = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    travelTo: {
      get () {
        return this.params.travelTo ? moment(this.travelTo, 'DD-MM-YYYY').toDate() : null
      },
      set (val) {
        this.params.travelTo = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    currencyOptions () {
      return currencies.map(el => ({ value: el.code, text: el.code }))
    }
  },
  methods: {
    onSubmit () {
      this.$emit('search', this.params)
    }
  }
}
</script>
